import { render, staticRenderFns } from "./FormInputPostalCode.vue?vue&type=template&id=35aad906&scoped=true&lang=pug"
import script from "./FormInputPostalCode.vue?vue&type=script&lang=ts"
export * from "./FormInputPostalCode.vue?vue&type=script&lang=ts"
import style0 from "./FormInputPostalCode.vue?vue&type=style&index=0&id=35aad906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aad906",
  null
  
)

export default component.exports